import type { StatusTone } from '@repletoryreach/sdk-ui/data-display';

/**
 * One mapping from a status code to a `StatusBadge` tone.
 *
 * There were four near-duplicates of this idea across the console
 * (`broadcasts/view[id]/components/OverviewTab.tsx`,
 * `templates/view[id]/index.tsx`,
 * `templates/view[id]/components/LifecycleTab.tsx`, and
 * `flows/view[id]/components/RunsTab.tsx`), two of them regex-based and each
 * disagreeing with the others about at least one code.
 */
const TONES: Record<string, StatusTone> = {
  // Finished, and finished well.
  approved: 'healthy',
  completed: 'healthy',
  delivered: 'healthy',
  active: 'healthy',
  sent: 'healthy',

  // Under way.
  running: 'pending',
  sending: 'pending',
  submitted: 'pending',
  in_progress: 'pending',
  queued: 'pending',

  // Finished badly.
  failed: 'down',
  rejected: 'down',
  error: 'down',

  // Stopped deliberately, which is not the same as broken.
  paused: 'warning',
  cancelled: 'warning',

  // Not started.
  draft: 'inactive',
  scheduled: 'inactive',
  inactive: 'inactive',
  archived: 'inactive'
};

/** Unknown codes fall back to `inactive`, never to a colour that implies health. */
export function statusTone(code: string | null | undefined): StatusTone {
  return TONES[(code ?? '').toLowerCase()] ?? 'inactive';
}
